<template>
  <div style="width: 100%">
    <v-card>
      <v-card-title>
        <h3 class="headline mt-0">{{ $t('Add/Remove to cart') }}</h3>
      </v-card-title>
      <v-card-text>
        <label>{{ $t('Options') }}</label>
        <div :class="{ 'has-error': errors.has('method') }" class="form-control mb-4">
          <v-radio-group
            v-model="optype"
            v-validate="'required'"
            :data-vv-as="$t('Options')"
            :error="errors.has('method')"
            :error-messages="errors.first('method')"
            name="method"
            row
          >
            <v-radio :label="$t('Add')" :value="'addtocart'" color="primary"></v-radio>
            <v-radio :label="$t('Remove')" :value="'removetocart'" color="primary"></v-radio>
            <v-radio
              v-if="!isThailandPostMart"
              :label="$t('Clear&Add')"
              :value="'removeandaddtocart'"
              color="primary"
            ></v-radio>
          </v-radio-group>
          <!-- <span class="text-error" v-if="errors.has('method')">{{ errors.first('method') }}</span> -->
        </div>
        <div v-for="(item, k) in items" :key="k">
          <v-card>
            <v-card-text style="position: relative">
              <div class="text-xs-right">
                <v-btn
                  icon
                  small
                  style="position: absolute; right: 0; top: 0"
                  @click="items.splice(k, 1)"
                >
                  <span class="material-icons">delete_outline</span>
                </v-btn>
              </div>
              <div :style="{ 'min-height': expandForSelect === k ? '300px' : '' }">
                <div :class="{ 'has-error': errors.has('product') }" class="form-control">
                  <label>{{ $t('Products') }}</label>
                  <template v-if="isThailandPostMart">
                    <multiselect
                      v-model="items[k]"
                      v-validate="'required'"
                      :close-on-select="true"
                      :data-vv-as="$t('Product')"
                      :internal-search="false"
                      :max-height="250"
                      :open-direction="'below'"
                      :options="filterProducts"
                      :placeholder="$t('Select Product')"
                      :searchable="true"
                      label="product_title"
                      name="product"
                      track-by="sku"
                      @close="expandForSelect = ''"
                      @open="expandForSelect = k"
                      @select="onThailandPostMartProductSelect(k)"
                      @search-change="debounceSearch"
                    ></multiselect>
                  </template>
                  <multiselect
                    v-else
                    v-model="item.pid"
                    v-validate="'required'"
                    :close-on-select="true"
                    :data-vv-as="$t('Product')"
                    :max-height="250"
                    :open-direction="'below'"
                    :options="filterProducts"
                    :placeholder="$t('Select Product')"
                    label="name"
                    name="product"
                    return="id"
                    @close="expandForSelect = ''"
                    @open="expandForSelect = k"
                    @select="onSelectedProduct(k)"
                  ></multiselect>
                  <span v-if="errors.has('product')" class="text-error">{{
                    errors.first('product')
                  }}</span>
                </div>
                <v-layout row rows wrap>
                  <v-flex v-if="!isThailandPostMart" lg7 style="padding-right: 5px" xs12>
                    <div :class="{ 'has-error': errors.has('option') }" class="form-control">
                      <label>{{ $t('stock') }}</label>
                      <multiselect
                        v-model="item.option"
                        v-validate="'required'"
                        :close-on-select="true"
                        :data-vv-as="$t('Options')"
                        :max-height="250"
                        :open-direction="'below'"
                        :options="$options.filters.filteredStock(item)"
                        :placeholder="$t('Select Stock')"
                        name="option"
                        @close="expandForSelect = false"
                        @open="expandForSelect = k"
                      ></multiselect>
                      <span v-if="errors.has('option')" class="text-error">{{
                        errors.first('option')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex lg3 xs12>
                    <div :class="{ 'has-error': errors.has('quantity') }" class="form-control">
                      <label>{{ $t('quantity') }}</label>
                      <input
                        v-if="isThailandPostMart"
                        v-model="item.quantity"
                        v-validate="'required'"
                        :data-vv-as="$t('quantity')"
                        name="quantity"
                        type="text"
                        @keypress="isNumber($event, item.quantity)"
                      />
                      <input
                        v-else
                        v-model="item.qty"
                        v-validate="'required'"
                        :data-vv-as="$t('quantity')"
                        name="quantity"
                        type="text"
                        @keypress="isNumber($event, item.qty)"
                      />
                      <span v-if="errors.has('quantity')" class="text-error">{{
                        errors.first('quantity')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex v-if="$store.getters.getPackage == 'premium'" lg2>
                    <IntentPrefillCartAddRemove
                      @onAddPrefill="onAddPrefill($event, item)"
                      @show=";['Number']"
                    ></IntentPrefillCartAddRemove>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="text-xs-center my-3">
          <v-btn color="green" flat @click="additem">
            <span class="material-icons">add</span>
            {{ $t('Add product') }}
          </v-btn>
        </div>

        <!-- <template v-if="$route.name == 'Comment to inbox' && optype == 'addtocart'">
          <v-divider />
          <h3 class="headline">{{ $t('Limit reply to inbox') }}</h3>
          <v-checkbox
            v-model="checkstock"
            color="primary"
            :label="$t('Reply to inbox depends on stock')"
            hide-details
            @change="changecheckstock"
          ></v-checkbox>
          <div class="ml-4 pl-2">
            <v-checkbox
              v-model="adjuststock"
              color="primary"
              :label="$t('Real-time inventory after reply to inbox')"
              hide-details
              :disabled="checkstock == false"
            ></v-checkbox>
          </div>
          <v-divider class="my-4" />
          <v-checkbox
            v-model="checksameproductincarts"
            color="primary"
            :label="$t('Refusing to reply users who has product(s) in the cart')"
            hide-details
          ></v-checkbox>
        </template> -->
        <div class="text-xs-center mt-2">
          <v-btn color="grey" outline @click="close">CANCEL</v-btn>

          <v-btn v-if="data" color="primary" depressed @click="update">UPDATE</v-btn>
          <v-btn v-else color="primary" depressed @click="save">SAVE</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import IntentPrefillCartAddRemove from '@/components/elements/IntentPrefillCartAddRemove.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'
import { debounce } from 'lodash'

export default {
  components: {
    multiselect,
    IntentPrefillCartAddRemove
  },
  props: ['data'],
  data() {
    return {
      optype: '',
      loading: false,
      expandForSelect: false,
      items: [
        {
          qty: '',
          pid: '',
          option: ''
        }
      ],
      checkstock: false,
      checksameproductincarts: false,
      adjuststock: false,
      thailandpostmartItems: [
        {
          sku: ''
        }
      ],
      thailandpostmartOptions: [],
      productSearch: [],
      debounceSearch: undefined
    }
  },
  created() {
    this.debounceSearch = debounce((searchText) => {
      if (searchText) {
        this.handleSearch(searchText)
      } else {
        this.productSearch = this.products
      }
    }, 300)
  },
  mounted() {
    if (this.data) {
      this.optype = this.data.type
      this.product = this.products.filter((el) => el.id == this.data.pid)[0]
      this.items = this.data.input
      if (!this.isThailandPostMart) {
        this.items = this.items.map((el) => {
          return { ...el, pid: this.products.find((val) => val.id == el.pid) }
        })
      }
      this.checksameproductincarts = this.data.hasOwnProperty('checksameproductincarts')
        ? this.data.checksameproductincarts
        : false
      this.checkstock = this.data.hasOwnProperty('checkstock') ? this.data.checkstock : false
      this.adjuststock = this.data.hasOwnProperty('adjuststock') ? this.data.adjuststock : false
    }
  },
  computed: {
    filterProducts() {
      return this.productSearch.length > 0 ? this.productSearch : this.products
    },
    // filterStocks() {
    //   if (this.product) {
    //     return this.product.productstock.map(el => el[1])
    //   } else {
    //     return []
    //   }
    // },
    ...mapGetters({ selectedBot: 'selectedBot', products: 'getProducts' }),
    isThailandPostMart() {
      return ['thailandpostmart'].includes(this.selectedBot.type)
    }
  },
  methods: {
    changecheckstock(value) {
      if (!value) {
        this.adjuststock = false
      }
    },
    isNumber: function (evt, qty) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) ||
        !/^[0-9]*$/gm.test(qty)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onAddPrefill(v, item) {
      item.qty = v
    },
    additem() {
      this.items.push({
        option: '',
        pid: '',
        qty: ''
      })
    },
    update() {
      if (this.isThailandPostMart) {
        this.$emit('updateRemoveAndAdd', {
          type: this.optype,
          data: this.items,
          index: this.data.index,
          checkstock: this.optype == 'addtocart' ? this.checkstock : false,
          checksameproductincarts:
            this.optype == 'addtocart' ? this.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? this.adjuststock : false
        })
      } else {
        var data = this.items.map((el) => {
          return { pid: el.pid.id, qty: el.qty, option: el.option }
        })
        this.$emit('updateRemoveAndAdd', {
          type: this.optype,
          data: data,
          index: this.data.index,
          checkstock: this.optype == 'addtocart' ? this.checkstock : false,
          checksameproductincarts:
            this.optype == 'addtocart' ? this.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? this.adjuststock : false
        })
      }

      this.close()
    },
    close() {
      this.optype = ''
      this.stock = ''
      this.product = ''
      this.quantity = ''
      this.$emit('close')
    },
    save() {
      var vm = this
      // var data = {
      //   pid: this.product.id,
      //   qty: this.quantity,
      //   option: this.stock
      // }
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }

        let data

        if (this.isThailandPostMart) {
          data = vm.items
        } else {
          data = vm.items.map((el) => {
            return { pid: el.pid.id, qty: el.qty, option: el.option }
          })
        }

        vm.$emit('addIntentItem', vm.optype, {
          obj: data,
          checkstock: this.optype == 'addtocart' ? vm.checkstock : false,
          checksameproductincarts: this.optype == 'addtocart' ? vm.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? vm.adjuststock : false
        })

        vm.close()
      })
    },
    onSelectedProduct(k) {
      this.items[k].option = ''
    },
    onThailandPostMartProductSelect(k) {
      this.$nextTick(() => {
        this.items[k].quantity = ''
      })
    },
    handleSearch(searchText) {
      const vm = this
      if (vm.selectedBot.type == 'thailandpostmart') {
        if (searchText) {
          return new Promise((resolve, reject) => {
            if (!vm.selectedBot) {
              reject()
            }
            let data = {
              slug: 'all',
              pageid: vm.selectedBot.pageid,
              search: searchText
            }
            if (searchText && searchText.trim()) data.search = searchText.trim()
            api.getProductBySlugThailandPostmart(data, function (error, response) {
              if (error) {
                resolve()
                return
              }
              if (response.data.length > 0) {
                vm.productSearch = []
                vm.productSearch = response.data
              } else {
                vm.productSearch = this.products
              }
              resolve()
            })
          })
        } else {
          vm.productSearch = []
        }
      }
    }
  },
  filters: {
    filteredStock: function (value) {
      if (value && value.pid) {
        return value.pid.productstock.map((el) => el[1])
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentCartAddRemove.vue